import React from 'react';
import { useSelector } from 'react-redux';
import { withTheme } from 'styled-components';
import { FovButton } from 'components/generic';
import { ReadyIcon } from 'components/icons';
import {
  DialogBackdrop,
  DialogCard,
  DialogIconWrap,
  DialogTitle,
  DialogText,
  ModelName,
  DialogActions,
  DismissButton,
} from './styles';

const JobReadyDialog = withTheme(props => {
  const { theme, job, onGoToFiles, onClose } = props;
  const userDataStore = useSelector(state => state.userData);
  const selectedTheme = userDataStore.userPreferences.theme;

  if (!job) return null;

  return (
    <DialogBackdrop theme={theme} $selectedTheme={selectedTheme} onClick={onClose}>
      <DialogCard
        theme={theme}
        $selectedTheme={selectedTheme}
        onClick={e => e.stopPropagation()}
      >
        <DialogIconWrap theme={theme} $selectedTheme={selectedTheme}>
          <ReadyIcon width={40} height={40} />
        </DialogIconWrap>

        <DialogTitle theme={theme} $selectedTheme={selectedTheme}>
          Your job is finished processing!
        </DialogTitle>

        <DialogText theme={theme} $selectedTheme={selectedTheme}>
          <ModelName theme={theme} $selectedTheme={selectedTheme}>
            {job.filename}
          </ModelName>
          {' '}is now ready.
        </DialogText>

        <DialogActions>
          <FovButton text='Go to my files' callback={onGoToFiles} />
          <DismissButton
            theme={theme}
            $selectedTheme={selectedTheme}
            onClick={onClose}
          >
            Dismiss
          </DismissButton>
        </DialogActions>
      </DialogCard>
    </DialogBackdrop>
  );
});

export { JobReadyDialog };
